import classNames from "classnames";
import styles from "../css/MultipleChoiceAnswerButton.module.css";
import { useCallback, useEffect, useState } from "react";

interface MultipleChoiceAnswerButtonProps {
  isAnswer: boolean;
  value: string;
  isResultMode: boolean;
  buttonNumber: number;
  onClick: (isAnswer: boolean) => void;
}

export function MultipleChoiceAnswerButton(
  props: MultipleChoiceAnswerButtonProps
) {
  const [isClicked, setIsClicked] = useState(false);

  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (
        props.buttonNumber !== undefined &&
        event.key === props.buttonNumber.toString()
      ) {
        handleOnClick();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.buttonNumber, props.onClick]
  );

  // 컴포넌트 마운트 시 키 이벤트 리스너 추가, 언마운트 시 제거
  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  const containerClass = classNames(styles.container, {
    [styles.resultMode]: props.isResultMode === true,
    [styles.containerCorrect]: props.isResultMode === true && props.isAnswer,
    [styles.containerIncorrect]:
      props.isResultMode === true && !props.isAnswer && isClicked,
  });

  function handleOnClick() {
    if (props.value === undefined || props.isResultMode) {
      return;
    }
    setIsClicked(true);
    props.onClick(props.isAnswer);
  }

  return (
    <button
      type="button"
      className={containerClass}
      aria-keyshortcuts={props.buttonNumber.toString()}
      aria-disabled={props.isResultMode || undefined}
      onClick={() => handleOnClick()}
    >
      <span className={styles.numberText} aria-hidden>
        {props.buttonNumber}
      </span>
      <span className={styles.value}>{props.value}</span>
    </button>
  );
}
